import { ActionTree } from 'vuex';
import { RootState } from '@/store/state';
import { RepeatableState } from '@/store/modules/repeatable/state';

export const actions: ActionTree<RepeatableState, RootState> = {};
